<template>
  <div
    class="submenu-drop-down"
    :class="openMenu === menu.identifier ? 'show' : ''"
  >
    <a
      href="#"
      @click.prevent="handleOpenMenu(menu.identifier)"
      :class="isActiveMenu({
        menu,
        defaultRoute,
        openMenu,
      }) ? 'active' : ''"
    >
      {{ menu.name }}
      <ChevronUp :size="18" class="chevron"></ChevronUp>
    </a>

    <ul tabindex="-1" class="dropdown-menu">
      <li role="presentation" v-for="item in menu.children" :key="item.uri">
        <a
          class="nav-link dropdown-toggle"
          :href="link(defaultRoute.menu, item.uri, !!item.frontendv2)"
          @click="
            handleSelectMenu({
              menu: defaultRoute.menu,
              submenu: item.uri,
              v2: !!item.frontendv2,
            })
          "
        >
          {{item.name}}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import ChevronUp from 'vue-material-design-icons/ChevronUp';
import { mapActions, mapState } from 'vuex';
import NavbarMixin from './NavbarMixin';

export default {
  components: {
    ChevronUp,
  },
  mixins: [NavbarMixin],
  props: [
    'menu',
  ],
  name: 'NavbarSubMenuDropDown',
  computed: {
    ...mapState('application', [
      'defaultRoute',
      'openMenu',
    ]),
  },
  methods: {
    ...mapActions('application', [
      'handleSelectMenu',
      'handleOpenMenu',
    ]),
  },
};
</script>
